module.exports = __webpack_public_path__ + "img/social_group_active.8815e2dc.svg";